import { message } from '../ts/utils/bootstrapModalHelper.js?_=3.8530.75.66';

document
	.querySelector('.mehrwert-bilder-liste')
	?.querySelectorAll('button')
	.forEach(elem => {
		elem.addEventListener('click', () => {
			message(`<img src="${elem.dataset.imageSrc}" />`, 'modal-xl modal-fullscreen-md-down mehrwert-bilder-modal', '', undefined, true, true, false);
		});
	});

document.querySelector('#mehrwert-bilder-filter')?.addEventListener('input', evt => {
	const filter = evt.target.value.trim().toLowerCase();
	let passend = 0;
	document.querySelectorAll('.mehrwert-bilder-liste button').forEach(elem => {
		if (!filter || elem.dataset.imageName.toLowerCase().includes(filter)) {
			passend++;
			elem.parentElement.hidden = false;
		} else {
			elem.parentElement.hidden = true;
		}
	});
	document.querySelector('#mehrwert-bilder-filter-treffer').textContent = `${passend} Bilder gefunden`;
});
